const BASE_URL = 'https://api.zhijiaoshu.com'
// const BASE_URL = 'http://127.0.0.1:8000'

const PayMethod = {
	AliWebPay: 1,
	WxWebPay: 2
}


module.exports = {
	PayMethod,
	BASE_URL
}